import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateVendorEmployee = createAsyncThunk('updateVendorEmployee', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'vendor_employee',
            data: data?.values,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
